export const FETCH_NOTIFICATIONS="FETCH_NOTIFICATIONS";
export const CLEAR_NOTIFICATIONS="CLEAR_NOTIFICATIONS";
export const TOGGLE_NOTIFICATIONS="TOGGLE_NOTIFICATIONS";